import { useEffect, useState } from 'react';
import firebaseApp from '../../../firebase-app';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import Variable from './components/variable';
import { Box, Button, Paper } from '@mui/material';
import { doc, setDoc } from 'firebase/firestore';
import Loading from '../../loading';
import { SxStyle } from '../../../types';
import { FS_PATH_FAQ_MAPPINGS } from '../../../constants';

const styles: SxStyle = {
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 4,
  },
  container: {
    padding: 4,
    height: 'calc(100% - 70px)',
    overflow: 'auto',
  },
};

const faqDoc = doc(firebaseApp.db, FS_PATH_FAQ_MAPPINGS);

function VariablesList() {
  const [faq, faqLoading] = useDocumentData<Record<string, string>>(faqDoc);
  const [variables, setVariables] = useState<{ key: string; value: string }[]>([]);

  useEffect(() => {
    if (faq) {
      const keys = Object.keys(faq).sort();
      setVariables(
        keys.map((key) => {
          return {
            key,
            value: faq[key],
          };
        })
      );
    }
  }, [faq]);

  const saveVariables = () => {
    setDoc(
      faqDoc,
      variables.reduce(
        (acc, variable) => {
          acc[variable.key] = variable.value;
          return acc;
        },
        {} as Record<string, string>
      )
    );
  };

  const onVariableChange = (oldKey: string, key: string, value: string) => {
    const vars = [...variables];
    const variable = vars.find((v) => v.key === oldKey);
    if (variable) {
      variable.key = key;
      variable.value = value;
    }
    setVariables(vars);
  };

  if (faqLoading) {
    return <Loading />;
  }

  return (
    <>
      <Box sx={styles.actions}>
        <Button variant="contained" color="primary" onClick={saveVariables}>
          Save
        </Button>
      </Box>
      <Paper elevation={4} sx={styles.container}>
        {variables.map((variable, index) => (
          <Variable
            key={index}
            name={variable.key}
            value={variable.value}
            onChange={onVariableChange}
          />
        ))}
      </Paper>
    </>
  );
}

export default VariablesList;
